module.exports = __webpack_public_path__ + "img/13.10ba6b53.jpg";